import { gql, useMutation } from '@apollo/client';
import React, { useContext } from 'react';

const CREATE_SETUP_INTENT = gql`
  mutation CreatePaymentCardSetupIntent {
    createPaymentCardSetupIntent {
      clientSecret
    }
  }
`;

interface SetupIntent {
  clientSecret?: string;
  refreshSetupIntent(): void;
}

export const SetupIntentContext = React.createContext<SetupIntent>({
  refreshSetupIntent: () => {
    return;
  },
});

/**
 * This is to use the SetupIntentContext, but most all sites using the payment element should access via the `useNewCardPaymentElement()` hook, not this one directly.
 */
export const useSetupIntent = () => {
  return useContext(SetupIntentContext);
};

/**
 * This is the hook to get the data that should be put into the SetupIntentContext.Provider, in ElementsProvider. No other components should really use this.
 */
export const useCreateSetupIntent = () => {
  const [createPaymentCardSetupIntent, { data }] = useMutation(CREATE_SETUP_INTENT);
  const clientSecret: string | undefined =
    data?.createPaymentCardSetupIntent?.clientSecret ?? undefined;
  return {
    clientSecret,
    refreshSetupIntent: createPaymentCardSetupIntent,
  };
};
